/* eslint-disable react-hooks/rules-of-hooks */
import { Button, Chip, Stack, TextField } from "@mui/material";
import ButtonCustom from "../../../components/ButtonCustom";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import useCreateStore from "../../../hooks/store/useCreateStore";
import useGetStoreDetails from "../../../hooks/store/useGetStoreDetails";
import { IStore } from "../../../utils/interfaces/IStore";
import useUpdateStore from "../../../hooks/store/useUpdateStore";
import { Store } from "@mui/icons-material";
import Grid from "@mui/material/Unstable_Grid2";
import { MuiTelInput } from "mui-tel-input";

function StoreRegisterPage() {
  const navigate = useNavigate();
  const { createStoreHooks } = useCreateStore();
  const { updateStoreHooks } = useUpdateStore();
  const params = useParams();
  const { data, isLoading } = useGetStoreDetails(params.id || "");
  const [isFormComplete, setIsFormComplete] = useState(false);
  const [title, setTitle] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [form, setForm] = useState<IStore | any>({
    endereco: "",
    cidade: "",
    estado: "",
    numero: "",
    storeModel: {
      idLoja: 0,
      idBranchLoja: "",
      nomeRestaurante: "",
      telefoneLoja: "",
      emailLoja: "",
      codFranqueado: 0,
    },
  });
  useEffect(() => {
    if (form) {
      const isComplete = Object.values(form).every(
        (value) => value !== "" && value !== null
      );
      setIsFormComplete(isComplete);
    }
  }, [form]);

  useEffect(() => {
    if (params.id) {
      setForm(data);
      setTitle("Editar Loja");
      setButtonText("Editar");
    } else {
      setTitle("Cadastrar Loja");
      setButtonText("Cadastrar");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  const save = () => {
    try {
      if (!params.id) {
        createStoreHooks(form)
          .then((resp) => {
            navigate("/store-list");
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else {
        updateStoreHooks(form)
          .then((resp) => {
            navigate("/store-list");
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    } catch {
      console.error("error");
    } finally {
    }
  };
  const handleChange = (campo: any, event: any) => {
    setForm({ ...form, [campo]: event });
  };

  const handleFunction = (campo: any, event: any) => {
    let updatedForm = { ...form };
    updatedForm.storeModel = {
      ...updatedForm.storeModel,
      [campo]: event,
    };
    setForm(updatedForm);
  };

  return (
    <Grid container spacing={2}>
      <Grid xs={12} md={12} lg={12} xl={12}>
        <Chip icon={<Store color="info" />} label={title} />
      </Grid>
      <Grid xs={12} md={12} lg={3} xl={3}>
        <TextField
          label="Sigla"
          variant="filled"
          fullWidth
          type="text"
          value={form?.storeModel?.idBranchLoja ?? ""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleFunction("idBranchLoja", event.target.value);
          }}
        />
      </Grid>
      <Grid xs={12} md={12} lg={9} xl={9}>
        <TextField
          label="Nome do Restaurante"
          variant="filled"
          fullWidth
          type="text"
          value={form?.storeModel?.nomeRestaurante ?? ""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleFunction("nomeRestaurante", event.target.value);
          }}
        />
      </Grid>
      <Grid xs={12} md={12} lg={3} xl={3}>
        <TextField
          label="Código Franqueado"
          variant="filled"
          fullWidth
          value={form?.storeModel?.codFranqueado ?? ""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleFunction("codFranqueado", event.target.value);
          }}
        />
      </Grid>
      <Grid xs={12} md={12} lg={3} xl={3}>
        <MuiTelInput
          variant="filled"
          fullWidth
          label="Telefone"
          value={form?.storeModel?.telefoneLoja ?? ""}
          onChange={(value: any) => {
            handleFunction("telefoneLoja", value);
          }}
        />
      </Grid>
      <Grid xs={12} md={12} lg={6} xl={6}>
        <TextField
          label="Email"
          variant="filled"
          fullWidth
          type="email"
          value={form?.storeModel?.emailLoja ?? ""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleFunction("emailLoja", event.target.value);
          }}
        />
      </Grid>

      <Grid xs={12} md={12} lg={12} xl={12}>
        <TextField
          label="Endereço"
          variant="filled"
          fullWidth
          value={form?.endereco ?? ""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleChange("endereco", event.target.value);
          }}
        />
      </Grid>
      <Grid xs={12} md={12} lg={4} xl={4}>
        <TextField
          label="Número"
          variant="filled"
          fullWidth
          value={form?.numero ?? ""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleChange("numero", event.target.value);
          }}
        />
      </Grid>
      <Grid xs={12} md={12} lg={4} xl={4}>
        <TextField
          label="Cidade"
          variant="filled"
          fullWidth
          value={form?.cidade ?? ""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleChange("cidade", event.target.value);
          }}
        />
      </Grid>
      <Grid xs={12} md={12} lg={4} xl={4}>
        <TextField
          label="Estado"
          variant="filled"
          fullWidth
          value={form?.estado ?? ""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleChange("estado", event.target.value);
          }}
        />
      </Grid>
      <Grid xs={12} md={12} lg={12} xl={12}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Button onClick={() => navigate(-1)}>Voltar</Button>
          <ButtonCustom
            text={buttonText}
            event={save}
            disabled={!isFormComplete}
          />
        </Stack>
      </Grid>
    </Grid>
  );
}

export default StoreRegisterPage;
